import type { ApiEvent } from 'modules/listing/api/event/types/ApiEvent';
import type { ApiInternship } from 'modules/listing/api/internship/types/ApiInternship';
import type { ApiJob } from 'modules/listing/api/job/types/ApiJob';
import type { ApiVolop } from 'modules/listing/api/volop/types/ApiVolop';
import type { SearchSavedListingsStore } from 'modules/search/zustand-stores/searchSavedListingsStore';

import { useSaveListing } from './useSaveListing';
import { useSaveOrgAfterListing } from './useSaveOrgAfterListing';

type Args = {
  listing: ApiJob | ApiInternship | ApiVolop | ApiEvent;
  initiallySaved: boolean;
  orgInitiallySaved: boolean;
  searchSavedListingsStore: SearchSavedListingsStore | null;
};

export function useSaveListingAndOrg({
  listing,
  initiallySaved,
  orgInitiallySaved,
  searchSavedListingsStore,
}: Args) {
  const {
    orgSaved,
    saveOrg,
    unsaveOrg,
    showSaveOrgTooltip,
    shouldShowSaveOrgTooltip,
    dismissSaveOrgTooltip,
  } = useSaveOrgAfterListing({
    orgId: listing.org?.id ?? null,
    orgName: listing.org?.name ?? null,
    orgType: listing.org?.orgType ?? null,
    orgInitiallySaved,
    searchSavedListingsStore,
  });

  const { save, saved, unsave } = useSaveListing({
    listingId: listing.id,
    listingName: listing.name,
    listingType: listing.type,
    initiallySaved,
    orgId: listing.org?.id ?? null,
    orgType: listing.org?.orgType ?? null,
    onSaved: showSaveOrgTooltip,
    onUnsaved: dismissSaveOrgTooltip,
    searchSavedListingsStore,
    trackClickEvent: true,
  });

  return {
    save,
    saved,
    unsave,
    orgSaved,
    saveOrg,
    unsaveOrg,
    shouldShowSaveOrgTooltip,
    dismissSaveOrgTooltip,
  };
}
